import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackComponent } from './components/callback/callback.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AddFormComponent } from './components/forms/add-form/add-form.component';
import { FormListComponent } from './components/forms/form-list/form-list.component';
import { LayoutListComponent } from './components/forms/layout-list/layout-list.component';
import { MasterListComponent } from './components/forms/master-list/master-list.component';
import { EditComponent } from './components/users/edit/edit.component';
import { ListComponent } from './components/users/list/list.component';
import { EditorRedirectComponent } from './editor-redirect/editor-redirect.component';
import { SSOLoginComponent } from './ssologin/ssologin.component';
import { ListRoleComponent } from './components/roles/list-role/list-role.component';
import { EditRoleComponent } from './components/roles/edit-role/edit-role.component';
import { NavigationNodeListComponent } from './components/navigation/navigation-node-list/navigation-node-list.component';
import { NavigationNodeFormComponent } from './components/navigation/navigation-node-form/navigation-node-form.component';
import { NavigationRuleListComponent } from './components/navigation/navigation-rule-list/navigation-rule-list.component';
import { NavigationRuleFormComponent } from './components/navigation/navigation-rule-form/navigation-rule-form.component';
import { UserSearchSettingListComponent } from './components/searchsettings/user-search-setting-list/user-search-setting-list.component';
import { UserSearchSettingFormComponent } from './components/searchsettings/user-search-setting-form/user-search-setting-form.component';
import { FormactionListComponent } from './components/formaction/formaction-list/formaction-list.component';
import { FormactionFormComponent } from './components/formaction/formaction-form/formaction-form.component';

const routes: Routes = [
  {path: '', component: DashboardComponent},
  {path: 'editor', component: EditorRedirectComponent},
  {path: 'sso', component: SSOLoginComponent},
  {path: 'callback', component: CallbackComponent},
  {path: 'users', component: ListComponent},
  {path: 'users/edit/:userId', component: EditComponent},
  {path: 'users/create', component: EditComponent},
  {path: 'roles', component: ListRoleComponent},
  {path: 'roles/create', component: EditRoleComponent},
  {path: 'roles/edit/:roleId', component: EditRoleComponent},
  {path: 'forms', component: FormListComponent},
  {path: 'forms/masters', component: MasterListComponent},
  {path: 'forms/layouts', component: LayoutListComponent},
  {path: 'forms/create', component: AddFormComponent},
  {path: 'navigation/nodes', component: NavigationNodeListComponent},
  {path: 'navigation/nodes/create', component: NavigationNodeFormComponent},
  {path: 'navigation/nodes/edit/:id', component: NavigationNodeFormComponent},
  {path: 'navigation/rules', component: NavigationRuleListComponent},
  {path: 'navigation/rules/create', component: NavigationRuleFormComponent},
  {path: 'navigation/rules/edit/:id', component: NavigationRuleFormComponent},
  {path: 'usersearchsetting', component: UserSearchSettingListComponent},
  {path: 'usersearchsetting/create', component: UserSearchSettingFormComponent},
  {path: 'usersearchsetting/edit/:id', component: UserSearchSettingFormComponent},
  {path: 'formaction', component: FormactionListComponent},
  {path: 'formaction/create', component: FormactionFormComponent},
  {path: 'formaction/edit/:id', component: FormactionFormComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 



}
